import { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { fireToastMessage } from "../toastContainer";
import useLoading from "../loader";
import { getOtp, resetPassword } from "../../services/auth";

const ForgetPasswordModal = ({ show, handleClose }) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState();
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errors, setErrors] = useState({});

  const { loading, withLoading } = useLoading(); // Use custom loading hook

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleRequestOTP = async () => {
    const newErrors = {};
    if (email && !email?.trim()) {
      newErrors.email = "Email is required!";
    } else if (!validateEmail(email)) {
      newErrors.email = "Invalid email format!";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    await withLoading(async () => {
      try {
        // await axios.post(`${url}/request-otp`, { email });
        const res = await getOtp(email);
        fireToastMessage({
          message: res.message,
          type: "success",
        });
        setStep(2);
      } catch (error) {
        fireToastMessage({
          message: "Failed to send OTP. Try again!",
          type: "error",
        });
      }
    });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!otp.trim()) newErrors.otp = "OTP is required!";
    if (!newPassword.trim()) {
      newErrors.newPassword = "Password is required!";
    } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(newPassword)) {
      newErrors.newPassword =
        "Password must be at least 8 characters long, contain an uppercase, a lowercase, and a number";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    await withLoading(async () => {
      try {
        const res = await resetPassword(otp, newPassword);
        // await axios.post(`${url}/reset-password`, { email, otp, newPassword });
        fireToastMessage({
          message: "Password changed successfully!",
          type: "success",
        });
        setStep(1);
        setEmail("");
        setOtp("");
        setNewPassword("");
        handleClose();
      } catch (error) {
        fireToastMessage({ message: error.message, type: "error" });
      }
    });
  };

  function handleClosed() {
    handleClose();
    setStep(1);
  }
  return (
    <Modal show={show} onHide={handleClosed} centered>
      <Modal.Header closeButton>
        <Modal.Title className="signin-para">Forgot Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {step === 1 ? (
          <>
            <p className="signin-para" style={{ textAlign: "center" }}>
              Enter your email to request an OTP
            </p>
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                placeholder="Enter your email"
                className={`input ${errors.email ? "is-invalid" : ""}`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && (
                <div className="error-message">{errors.email}</div>
              )}
            </Form.Group>
            <button
              className="submit-btn"
              style={{ width: "100%" }}
              onClick={handleRequestOTP}
            >
              Request OTP
            </button>
          </>
        ) : (
          <>
            <p className="signin-para" style={{ textAlign: "center" }}>
              Enter the OTP and your new password
            </p>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Enter OTP"
                className={`input ${errors.otp ? "is-invalid" : ""}`}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              {errors.otp && <div className="error-message">{errors.otp}</div>}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Enter new password"
                className={`input ${errors.newPassword ? "is-invalid" : ""}`}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              {errors.newPassword && (
                <div className="error-message">{errors.newPassword}</div>
              )}
            </Form.Group>
            <button
              className="submit-btn"
              style={{ width: "100%" }}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ForgetPasswordModal;
